import Layzr from 'layzr.js'
import throttle from 'lodash.throttle'
import { addClass, closest, on, select } from 'modules/dom'
import objectFit from 'object-fit'

const instance = Layzr({
  threshold: 100
})

const closestWrapper = closest('.js-wrap')
const loaded = addClass('image--loaded')
const wrapper = select('.js-wrapper')

instance.on('src:after', img => {
  const wrapperImg = closestWrapper(img)

  if (!wrapperImg) {
    return
  }

  loaded(wrapperImg)
})

export const updateLazyLoad = () => instance.update().check()

updateLazyLoad().handlers(true)

if (wrapper) {
  on('scroll', throttle(() => instance.check()), wrapper)
}

export default (el) => {
  objectFit.polyfill({
    selector: el,
    fittype: el.classList.contains('image--contain') ? 'contain' : 'cover',
    disableCrossDomain: true
  })
  instance
    .update()
    .check()
    .handlers(true)
}
